import React from 'react';
import { Home, ArrowLeft } from 'lucide-react';

const AppHeader = ({ title, subtitle, leftSlot, rightSlot, onBack, onHome, className = '', titleBelow = false }) => {
    return (
        <header className={`w-full flex flex-col gap-4 mb-8 ${className}`}>
            <div className="flex items-center justify-between min-h-[48px] gap-4">
                {/* Navigation / Left Slot */}
                <div className="flex items-center gap-2 min-w-[48px] flex-shrink-0">
                    {onBack && (
                        <button onClick={onBack} className="p-2 rounded-full bg-surface hover:bg-surface-hover text-muted hover:text-main transition-colors shadow-sm" title="Go Back">
                            <ArrowLeft size={24} />
                        </button>
                    )}
                    {onHome && (
                        <button onClick={onHome} className="p-2 rounded-full bg-surface hover:bg-surface-hover text-muted hover:text-main transition-colors shadow-sm" title="Home">
                            <Home size={24} />
                        </button>
                    )}
                    {leftSlot}
                </div>

                {/* Center Title (only if not titleBelow) */}
                {!titleBelow && (
                    <div className="flex-1 flex flex-col items-center text-center px-2 overflow-hidden">
                        <h1 className="text-2xl md:text-3xl font-black text-primary tracking-tight leading-tight truncate w-full">
                            {title}
                        </h1>
                        {subtitle && <p className="text-xs md:text-sm text-muted font-medium truncate w-full">{subtitle}</p>}
                    </div>
                )}

                {/* Right Slot */}
                <div className="flex items-center justify-end min-w-[48px] flex-shrink-0">
                    {rightSlot}
                </div>
            </div>

            {/* Title Section (Displayed below slots if titleBelow is true or on very narrow mobile) */}
            {titleBelow && (
                <div className="flex flex-col items-center text-center px-4 animate-in fade-in slide-in-from-top-2">
                    <h1 className="text-4xl md:text-5xl font-black text-primary tracking-tight leading-tight drop-shadow-sm">
                        {title}
                    </h1>
                    {subtitle && <p className="text-sm md:text-base text-muted font-medium mt-1">{subtitle}</p>}
                </div>
            )}
        </header>
    );
};

export default AppHeader;
